import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { readCookieConsent, writeCookieConsent } from '../utils/cookieConsent';

const CookieConsentContext = createContext(null);

export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(() => readCookieConsent());
  const [bannerOpen, setBannerOpen] = useState(() => !readCookieConsent());

  const persist = useCallback((analytics) => {
    const next = writeCookieConsent({ analytics });
    setConsent(next);
    setBannerOpen(false);
    return next;
  }, []);

  const acceptAll = useCallback(() => persist(true), [persist]);
  const rejectNonEssential = useCallback(() => persist(false), [persist]);
  const openCookieSettings = useCallback(() => setBannerOpen(true), []);

  const value = useMemo(
    () => ({
      consent,
      bannerOpen,
      hasChosen: Boolean(consent),
      analyticsAllowed: consent?.analytics === true,
      acceptAll,
      rejectNonEssential,
      openCookieSettings,
    }),
    [consent, bannerOpen, acceptAll, rejectNonEssential, openCookieSettings]
  );

  return <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>;
};

export const useCookieConsent = () => {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) {
    throw new Error('useCookieConsent must be used within a <CookieConsentProvider>');
  }
  return ctx;
};

export default CookieConsentContext;
